var screenVw = jQuery(window).width();
var screenVh = jQuery(window).height();
var screenHalf = screenVh + 600;
var mobileBreakpoint = 1023;
var lazyloadOptions = {
	elements_selector: '.lazy, .image-bg-lazy',
	threshold: 300,
	class_loading: 'lazyload-loading',
	class_loaded: 'lazyload-loaded'
};
var lazyLoad;



whatInput = whatInput.ask() // returns `mouse`, `keyboard` or `touch`

jQuery(document).ready(function($){

	 $('.slider-lab-wrapper').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: true,
	  dots:false,
	  speed: 250,
	  fade: true
	  });

	$('.toggle-navsecondary').click(function(e) {
		$('header').toggleClass('active-nav');
		$('header').removeClass('active-search');
		$(this).toggleClass('active');
		$('.toggle-search').removeClass('active');
	});
	$('.toggle-search').click(function(e) {
		$('header').toggleClass('active-search');

		$(this).toggleClass('active');
		

	});







	$('.accessibility-link-slideshow').keypress(function() {
		$('.slide-home-content-navigation').slick('slickPause');
		$('.slide-home-content-slide-nav-play-toggle').toggleClass('paused');





  	});



function scrollLoad() {
	lazyLoad = new LazyLoad(lazyloadOptions);
}

window.onscroll = function() {
	scrollLoad();
	Waypoint.refreshAll();

};




	if ($('body').hasClass('search-results')) {


		//  $('.grid-square-search').slick({
		//   slidesToShow: 3,
		//   centerMode:true,
		//   false:false,
		//   dots:false,
		//   fade: true


		// });

	}


	if ($('body').hasClass('page-template-front-page')) {
			
		closeAlertWindow();

		//Get the tools of the toolset
	    var toolURL = site.root + '/wp-json/wp/v2/tool-types';
		fetch(toolURL, {
			    method: 'GET',
			    headers:{
			        'Content-Type': 'application/json',
			        'accept': 'application/json',
			    }
			}).then(function(response){
			    return response.json();
			}).then(function(post){

              $.each(post, function(i, item) {
		    	var title = post[i].name;
		    	var id = post[i].id;
		    	var link = post[i].link;

				$('.section-links-tooltypes ul').append('<li class="tool tool-id-' + id + '"><a href="' + link + '" rel="' + id + '"></a>' + title + '</li>');

            });

		});


		//Get the featured pages of the home page
	    var promoBaseURL = site.root + '/wp-json/wp/v2/pages';
	    var promoURL = promoBaseURL + '/' + 6;

		fetch(promoURL, {
			    method: 'GET',
			    headers:{
			        'Content-Type': 'application/json',
			        'accept': 'application/json',
			    }
			}).then(function(response){
			    return response.json();
			}).then(function(post){

				

		setTimeout(function() {


		 $('.slide-home-content-navigation').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  autoplay:true,
		  autoplaySpeed: 5000,
		  dots:false,
		    speed: 0,
		  fade: true,
		  asNavFor: '.slide-home',
      		prevArrow: $('.slide-navigation-prev'),
      		nextArrow: $('.slide-navigation-next'),
	        focusOnSelect: true


		});
		 $('.slide-home-art-wrapper').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  dots:false,
		  arrows: false,
		  speed: 250,
		  fade: true,
		  asNavFor: '.slide-home'
		});
		$('.slide-home-content-headline').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: false,
		  asNavFor: '.slide-home',
		  dots: true,
		  speed: 0,
		  fade: true
		 });

		$('.slide-home-art-wrapper').on('afterChange', function(event, slick, currentSlide){
		    $('.image-mask').removeClass('animated bounce');
		});

		$('.slide-home-art-wrapper').on('beforeChange', function(event, slick, currentSlide){
		    $('.image-mask').addClass('animated bounce');
		});
		$('.slide-home-content-navigation').on('afterChange', function(event, slick, currentSlide){
		     $('.slide-link').addClass('underline');
		});

		$('.slide-home-art-wrapper').on('beforeChange', function(event, slick, currentSlide){
		   $('.slide-link').removeClass('underline');
		});

		}, 25);

			setTimeout(function() {
				$('.slider-home').addClass('loaded');
			}, 25);
			  
			$('.slide-navigation-pause').click(function() {
				$('.slide-home-content-navigation').slick('slickPause');
				$('.slide-home-content-slide-nav-play-toggle').toggleClass('paused');

			});
			$('.slide-navigation-play').click(function() {
				$('.slide-home-content-navigation').slick('slickPlay');
				$('.slide-home-content-slide-nav-play-toggle').toggleClass('paused');
			});

		});
if ($(window).width() >= mobileBreakpoint) {

  var slidesWaypoint = $('.section-slider').waypoint(function(direction) {


		if (direction === 'down') {
				$('.slide-home-art').addClass('fixed');
	    } else {
				$('.slide-home-art').removeClass('fixed');
				
		}
	});
  var slidesWaypointRemove = $('.uw-thinstrip').waypoint(function(direction) {


		if (direction === 'down') {
	    } else {
				$('.slide-home-art').removeClass('fixed');
				
		}
	});

  var footerWaypoint = $('.section-spacer-slider-release').waypoint(function(direction) {
		if (direction === 'down') {

			$('.slide-home-art').removeClass('fixed');
				$('.slide-home-art').addClass('bottom');
    } else {
			$('.slide-home-art').addClass('fixed');
				$('.slide-home-art').removeClass('bottom');
		}
	}, {
		offset: screenVh 
  });


		var toolOverviewWaypoint = $('.section-scroll').waypoint(function(direction) {
			if (direction === 'down') {
				$('.section-scroll-overview').addClass('fixed');
		} else {
				$('.section-scroll-overview').removeClass('fixed');
			}
		}, {
				offset: + 32
		  });


	  var contentRelease = $('.section-spacer-content-release').waypoint(function(direction) {
			if (direction === 'down') {
				$('.section-scroll-overview').removeClass('fixed');
				$('.section-scroll-overview').addClass('bottom');
	    } else {
				$('.section-scroll-overview').addClass('fixed');
				$('.section-scroll-overview').removeClass('bottom');
			}
		}, {
			offset: screenVh - 32
	  });



	}
	};
	
	if ($('body').hasClass('page-template-secondary-page')) {

		 $('.slide-tool-art-wrapper').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: false,
		  speed: 250,
		  fade: true,
		  asNavFor: '.slide-tool'
		});
		$('.slide-tool-content-block-wrapper').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  asNavFor: '.slide-tool',
		  speed: 500,
		  dots: false,
		  fade: false,
		  arrows: true,
		  focusOnSelect: true
		});

			$('.slide-tool-art-wrapper').on('afterChange', function(event, slick, currentSlide){
			    $('.slide-tool-art').addClass('animate');
			});

			$('.slide-home-art-wrapper').on('beforeChange', function(event, slick, currentSlide){
			    $('.slide-tool-art').removeClass('animate');
			});
if ($(window).width() >= mobileBreakpoint) {

		var asideWaypoint = $('.section-content').waypoint(function(direction) {
			if (direction === 'down') {
				$('aside').addClass('fixed');
		} else {
				$('aside').removeClass('fixed');
			}
		}, {
				offset: -100
		  });

	};
	};

	if ($('body').hasClass('page-template-services-page')) {

if ($(window).width() >= mobileBreakpoint) {

		var asideWaypoint = $('.section-columns').waypoint(function(direction) {
			if (direction === 'down') {
				$('.section-column-services-art').addClass('fixed');
		} else {
				$('.section-column-services-art').removeClass('fixed');
			}
		}, {
				offset: 32
		  });

		var asideWaypoint = $('.section-spacer-content-release').waypoint(function(direction) {
			if (direction === 'down') {
				$('.section-column-services-art').removeClass('fixed');
				$('.section-column-services-art').addClass('bottom');
		} else {
				$('.section-column-services-art').addClass('fixed');
				$('.section-column-services-art').removeClass('bottom');
			}
		}, {
			offset: screenVh
		  });
	};


      $('.section-accordion-header').click(function() {
          $(this).parent().toggleClass('open');
          		Waypoint.refreshAll();
			    $('html, body').delay(100).animate({
			      scrollTop: $(this).offset().top - 32
			    }, 500);

			    $imageURL = $(this).attr('data-url');


				document.getElementById("section-column-services-art").src= $imageURL;


       });




}
if ($(window).width() >= mobileBreakpoint) {

	if ($('body').hasClass('parent-pageid-8')) {
		var asideWaypoint = $('.section-content').waypoint(function(direction) {
			if (direction === 'down') {
				$('aside').addClass('fixed');
		} else {
				$('aside').removeClass('fixed');
			}
		}, {
				offset: -100

		  });

	  var contentRelease = $('.section-spacer-content-release').waypoint(function(direction) {
			if (direction === 'down') {
			$('aside').removeClass('fixed');
				$('aside').addClass('bottom');
	    } else {
			$('aside').addClass('fixed');
				$('aside').removeClass('bottom');
			}
		}, {
			offset: screenVh - 32
	  });	

	}

	if ($('body').hasClass('page-id-14')) {

		var asideWaypoint = $('.section-content').waypoint(function(direction) {
			if (direction === 'down') {
				$('aside').addClass('fixed');
		} else {
				$('aside').removeClass('fixed');
			}
		}, {
				offset: -100

		  });

	  var contentRelease = $('.section-spacer-content-release').waypoint(function(direction) {
			if (direction === 'down') {
				$('aside').addClass('bottom');
	    } else {
				$('aside').removeClass('bottom');
			}
		}, {
			offset: screenVh - 32
	  });	

	}
	};


	if ($('body').hasClass('page-template-primary-page')) {

if ($(window).width() >= mobileBreakpoint) {

		var toolOverviewWaypoint = $('.section-scroll').waypoint(function(direction) {
			if (direction === 'down') {
				$('.section-scroll-overview').addClass('fixed');
		} else {
				$('.section-scroll-overview').removeClass('fixed');
			}
		}, {
				offset: 32
		  });


	  var contentRelease = $('.section-spacer-content-release').waypoint(function(direction) {
			if (direction === 'down') {
				$('.section-scroll-overview').removeClass('fixed');
				$('.section-scroll-overview').addClass('bottom');
	    } else {
				$('.section-scroll-overview').addClass('fixed');
				$('.section-scroll-overview').removeClass('bottom');
			}
		}, {
			offset: screenVh - 32
	  });	
	}
	}

	if ($('body').hasClass('page-id-10')) {
					closeToolWindow();

			if ($(window).width() >= mobileBreakpoint) {
				if (window.location.href.indexOf('?toolID=') > 0) {
					loadToolByID();
	       		};
				loadToolCategoryByClick();

				if (window.location.href.indexOf('?to=') > 0) {
					loadToolCategoryByURL();
			    };


			}
		
			if ($(window).width() <= mobileBreakpoint) {
				loadToolCategoryByMobile();

			}
		
			$('.toggle-tool-icon').click(function(e) {
					if ($(window).width() >= mobileBreakpoint) {
						loadToolsByCategory();

					}

					if ($(window).width() <= mobileBreakpoint) {
						loadToolsByCategoryMobile();

					}

				    $([document.documentElement, document.body]).animate({
				        scrollTop: $('#our-tools').offset().top -32
				    }, 350);
					$(this).toggleClass('active');
					$('.section-tool-list').toggleClass('active');


			});	    





	}
	if ($('body').hasClass('page-id-8')) {
		

	}
	




	$(".slider-about").slick({
	  infinite: false,
	  dots: true,
	  centerMode: false,
	  draggable: false,
	  variableWidth: true,
	  responsive: [{
	      breakpoint: 767,
	      settings: "unslick" 

	    }]
	});

	$(".slider-interior").slick({
	  infinite: true,
	  dots: false,
	  centerMode: false,
	  draggable: false,
	  variableWidth: false
	});


// load posts based on id in URL
function loadToolCategoryByURL() {

		$('.section-content-related').empty();
		$('.section-content-related').addClass('active');
		
	    $([document.documentElement, document.body]).animate({
	        scrollTop: $('.section-content-related').offset().top
	    }, 250);

		var toolGroupID = getParameterByName('to');
		var tooltypeURL = site.root + '/wp-json/wp/v2/tool-types/';
		var toolsbytypeURL = site.root + '/wp-json/wp/v2/tool/?tool-types=';
        var tooltypeTools = toolsbytypeURL + toolGroupID + '&_embed&per_page=100';
    	var tooltypeInfo = tooltypeURL + toolGroupID ;

		$('.section-content-related').append('<div class="slider-tools"><div class="slide-tool slide-tool-art-wrapper"></div><div class="slide-tool-content-wrapper loading"><div class="slide-tool-navigation active"><div class="slide-tool-navigation-buttons"><button class="close-modal button-x">Close Tool Viewer</button><button class="slick-arrow-control slick-prev slide-navigation-prev-tooltype">View Previous Tool</button><button class="slick-arrow-control slick-next slide-navigation-next-tooltype">View Next Tool</button><button class="slick-all slide-navigation-view-tools hidden" id="tooltoggle">Hide Tool List</button></div></div><h2 class="loading-message">Loading tools</h2><div class="slide-tool slide-tool-content-block-wrapper"></div></div></div></div>');
		$('.slide-tool-navigation').append('');

		fetch(tooltypeInfo, {
	    method: 'GET',
	    headers:{
	        'Content-Type': 'application/json',
	        'accept': 'application/json',
	    }
		}).then(function(response){
		    return response.json();
		}).then(function(post){
    		var toolGroupName = post.slug ;


				$('.slide-tool-art-wrapper').append('<div class="slide-tool-art"><span class="media-wrapper"></span></div>');
				$('.slider-tools').append('<span class="media-wrapper media-wrapper-tooltype loading" role="img" aria-label="' + post.name + '" style="background-image:url(' + post.acf.tooltype_image.url + ')"></span>');

				$('.slide-tool-content-block-wrapper').append('<div class="slide-tool-content-block"><h2>Tools To: <span class="title">' + post.name + '</span><span class="description">' + post.description + '</div></h2></div>');
				$('.slide-tool-content-wrapper').append('<div class="slide-tool-list-wrapper"><div class="slide-tool-list ' + toolGroupName +'"></div></div>');

         });	     

			fetch(tooltypeTools, {
			    method: 'GET',
			    headers:{
			        'Content-Type': 'application/json',
			        'accept': 'application/json',
			    }
				}).then(function(response){
				    return response.json();
				}).then(function(post){
						// $('.slide-tool-art-wrapper').append('<div class="slide-tool-art"><div class="media-wrapper" style="background-image:url()"></div></div>');
						// $('.slide-tool-content-block-wrapper').append('<div class="slide-tool-content-block"><h2>' + toolGroupName + '</h2></div>');
						// $('.slide-tool-content-wrapper').append('<div class="slide-tool-list"></div>');
	              	$.each(post, function(i, item) {
				    	var title = post[i].title.rendered;
				    	var content = post[i].content.rendered;
				    	var id = post[i].id;
				    	var link = post[i].link;

						var toolImage = post[i]._embedded['wp:featuredmedia'][0].source_url;
      					var image = site.themePath + '/dist/images/logos/logo-pattern.png';
						if (toolImage != null) {
						        var image = toolImage;
						}

						
						$('.slide-tool-list').append('<a href="#" rel="' + (i+1) + '">' + title + '</a>');
						$('.slide-tool-art-wrapper').append('<div class="slide-tool-art"><span class="media-wrapper" role="img" aria-label="' + title + '" style="background-image:url(' + image + ')"></span></div>');
						$('.slide-tool-content-block-wrapper').append('<div class="slide-tool-content-block"><h2>' + title + '</h2><p>' + content + '</p><a href="'+ site.root + '/contact-us/?linkfrom=' + title + '" class="related-link small purple">Speak to a team member about this tool</a></div>');

	            	});	              

		              setTimeout(function() {
		              		$('.media-wrapper-tooltype').removeClass('loading');
			              	$('.slide-tool-content-wrapper').removeClass('loading');
							$('.slide-tool-navigation-buttons .close-modal').focus();

						}, 1);


		              	

							$('.slick-all').click(function(e) {
							    $('.slide-tool-art').addClass('animate');
							    $('.slide-tool-list-wrapper').toggleClass('hidden');

							      $(this).text(function(i, text){
							          return text === "Hide Tool List" ? "Show Tools" : "Hide Tool List";
							      })

							});	    


							$('.slick-arrow-control').click(function(e) {
						    $('.slide-tool-list-wrapper').addClass('hidden');
							document.getElementById("tooltoggle").innerHTML = "Show Tools";

							});	    


	          				

						$('.slide-tool-art-wrapper').on('init reInit afterChange', function(event, slick, currentSlide){
						    $('.slide-tool-art').addClass('animate');

						    $('.slide-tool-list-wrapper').addClass('hidden');
						    $('.media-wrapper-tooltype').addClass('hidden');
									$('.slick-all').removeClass('hidden');

							    var i = (currentSlide ? currentSlide : 0) + 1;
								if (i == '1') {
							    	$('.media-wrapper-tooltype').removeClass('hidden');
									$('.slick-all').addClass('hidden');

						    		$('.slide-tool-list-wrapper').removeClass('hidden');
								      $('.slick-all').text(function(i, text){
								          return text === "Show Tools" ? "Hide Tool List" : "Show Tools";
								      })

								}
					    	
					    	

						});

						$('.slide-home-art-wrapper').on('beforeChange', function(event, slick, currentSlide){
						    $('.slide-tool-art').removeClass('animate');
						});

		              setTimeout(function() {

						 $('.slide-tool-art-wrapper').slick({
						  slidesToShow: 1,
						  slidesToScroll: 1,
						  arrows: false,
						  speed: 250,
						  fade: true,
						  asNavFor: '.slide-tool'
						});
						$('.slide-tool-content-block-wrapper').slick({
						  slidesToShow: 1,
						  slidesToScroll: 1,
						  asNavFor: '.slide-tool',
						  speed: 500,
						  dots: false,
						  fade: false,
				      		prevArrow: $('.slide-navigation-prev-tooltype'),
				      		nextArrow: $('.slide-navigation-next-tooltype'),
						  focusOnSelect: true
						});

							
						}, 1);

						$('.slide-tool-list a').click(function(e) {
				        	e.preventDefault();

							var slidenumber = $(this).index();
							var slidenumber = $(this).attr('rel');
							// console.log(slidenumber);
							// // subtract one to go to correct slide
							var slideIndex = slidenumber;
								$('.slide-tool-content-block-wrapper' ).slick('slickGoTo', slideIndex, false);
									$('.slide-tool-navigation').removeClass('active');
									  $('.slick-all').removeClass('visible');
								      $('.slick-all').text(function(i, text){
								          return text === "Show Tools" ? "Hide Tool List" : "Show Tools";
								      });
									

				              setTimeout(function() {

											$('.slide-navigation-next-tooltype').focus();

								}, 1);


						});	    
						closeToolWindow();
	         });
      
	}	



function loadToolCategoryByClick() {

		$('a.tool-link').click(function(e) {
        	e.preventDefault();


		    var toolGroup = $(this).attr('rel');
		    var toolGroupName = $(this).attr('data-name');
			var basicURL = site.root + '/wp-json/wp/v2/tool/?tool-types=';
            var fullURL = basicURL + toolGroup + '&_embed&per_page=100';

	        var baseParam = '?to=';
	        var fullParam = baseParam + toolGroup;
			$('.section-content-related').empty();
			$('.section-content-related').addClass('active');			
			$('.section-content-related').append('<div class="slider-tools"><div class="slide-tool slide-tool-art-wrapper"></div><div class="slide-tool-content-wrapper loading"><div class="slide-tool-navigation active"><div class="slide-tool-navigation-buttons"><button class="close-modal button-x">Close Tool Viewer</button><button class="slick-arrow-control slick-prev slide-navigation-prev-tooltype">View Previous Tool</button><button class="slick-arrow-control slick-next slide-navigation-next-tooltype">View Next Tool</button><button class="slick-all slide-navigation-view-tools hidden" id="tooltoggle">Show Tools</button></div></div><h2 class="loading-message">Loading tools</h2><div class="slide-tool slide-tool-content-block-wrapper"></div></div></div></div>');
			$('.slide-tool-navigation').append('');

	      	if (history.pushState) {
	          var newurl = window.history.pushState({}, document.title,  site.root + "/tools/" + fullParam);
	          window.history.pushState({path:newurl},'',newurl);
		    }

			var tooltypeURL = site.root + '/wp-json/wp/v2/tool-types/';
        	var tooltypefullURL = tooltypeURL + toolGroup ;

			fetch(tooltypefullURL, {
		    method: 'GET',
		    headers:{
		        'Content-Type': 'application/json',
		        'accept': 'application/json',
		    }
			}).then(function(response){
			    return response.json();
			}).then(function(post){
				$('.slide-tool-art-wrapper').append('<div class="slide-tool-art"><span class="media-wrapper"></span></div>');
				$('.slider-tools').append('<span class="media-wrapper media-wrapper-tooltype loading" role="img" aria-label="' + post.name + '" style="background-image:url(' + post.acf.tooltype_image.url + ')"></span>');
				$('.slide-tool-content-block-wrapper').append('<div class="slide-tool-content-block"><h2>Tools To: <span class="title">' + post.name + '</span><span class="description">' + post.description + '</div></h2></div>');
				$('.slide-tool-content-wrapper').append('<div class="slide-tool-list-wrapper"><div class="slide-tool-list ' + toolGroupName +'"></div></div>');
	         });	              
      
			fetch(fullURL, {
			    method: 'GET',
			    headers:{
			        'Content-Type': 'application/json',
			        'accept': 'application/json',
			    }
				}).then(function(response){
				    return response.json();
				}).then(function(post){

						// $('.slide-tool-art-wrapper').append('<div class="slide-tool-art"><div class="media-wrapper" style="background-image:url()"></div></div>');
						// $('.slide-tool-content-block-wrapper').append('<div class="slide-tool-content-block"><h2>' + toolGroupName + '</h2></div>');
						// $('.slide-tool-content-wrapper').append('<div class="slide-tool-list"></div>');
		              setTimeout(function() {

		              		$('.media-wrapper-tooltype').removeClass('loading');
			              	$('.slide-tool-content-wrapper').removeClass('loading');
							$('.slide-tool-navigation-buttons .close-modal').focus();

						}, 1);

		              	

							$('.slick-all').click(function(e) {
							    $('.slide-tool-art').addClass('animate');
							    $('.slide-tool-list-wrapper').toggleClass('hidden');

							      $(this).text(function(i, text){
							          return text === "Hide Tool List" ? "Show Tools" : "Hide Tool List";
							      })

							});	    


							$('.slick-arrow-control').click(function(e) {
						    $('.slide-tool-list-wrapper').addClass('hidden');
							document.getElementById("tooltoggle").innerHTML = "Show Tools";


							});	    

	              	$.each(post, function(i, item) {
				    	var title = post[i].title.rendered;
				    	var content = post[i].content.rendered;
				    	var id = post[i].id;
				    	var link = post[i].link;

						var toolImage = post[i]._embedded['wp:featuredmedia'][0].source_url;
      					var image = site.themePath + '/dist/images/logos/logo-pattern.png';
						if (toolImage != null) {
						        var image = toolImage;
						}


						$('.slide-tool-list').append('<a href="#" rel="' + (i+1) + '" data-id="' + id + '">' + title + '</a>');
						$('.slide-tool-art-wrapper').append('<div class="slide-tool-art"><span class="media-wrapper" role="img" aria-label="' + title + '" style="background-image:url(' + image + ')"></span></div>');
						$('.slide-tool-content-block-wrapper').append('<div class="slide-tool-content-block" data-id="' + id + '"><h2>' + title + '</h2><p>' + content + '</p><a href="'+ site.root + '/contact-us/?linkfrom=' + title + '" class="related-link small purple">Speak to a team member about this tool</a></div>');


	            	});	              


	          				

						$('.slide-tool-art-wrapper').on('init reInit afterChange', function(event, slick, currentSlide){
						    $('.slide-tool-art').addClass('animate');
						    $('.slide-tool-list-wrapper').addClass('hidden');
						    $('.media-wrapper-tooltype').addClass('hidden');
							$('.slick-all').removeClass('hidden');



							    var i = (currentSlide ? currentSlide : 0) + 1;
								if (i == '1') {
							    	$('.media-wrapper-tooltype').removeClass('hidden');
									$('.slick-all').addClass('hidden');

						    		$('.slide-tool-list-wrapper').removeClass('hidden');
								      $('.slick-all').text(function(i, text){
								          return text === "Show Tools" ? "Hide Tool List" : "Show Tools";
								      })

								}
					    	
					    	

						});




						$('.slide-home-art-wrapper').on('beforeChange', function(event, slick, currentSlide){
						    $('.slide-tool-art').removeClass('animate');
						});

		              setTimeout(function() {

						 $('.slide-tool-art-wrapper').slick({
						  slidesToShow: 1,
						  slidesToScroll: 1,
						  arrows: false,
						  speed: 250,
						  fade: true,
						  asNavFor: '.slide-tool'
						});
						$('.slide-tool-content-block-wrapper').slick({
						  slidesToShow: 1,
						  slidesToScroll: 1,
						  asNavFor: '.slide-tool',
						  speed: 500,
						  dots: false,
						  fade: false,
				      		prevArrow: $('.slide-navigation-prev-tooltype'),
				      		nextArrow: $('.slide-navigation-next-tooltype'),
						  focusOnSelect: true
						});

							
						}, 1);

						$('.slide-tool-list a').click(function(e) {
				        	e.preventDefault();


							var slidenumber = $(this).index();
							var slideID = $(this).attr('data-id');
							var slidenumber = $(this).attr('rel');
							// console.log(slidenumber);
							// // subtract one to go to correct slide
					      	if (history.pushState) {
					          var newurl = window.history.pushState({}, document.title,  site.root + "/tools/?toolID=" + slideID);
					          window.history.pushState({path:newurl},'',newurl);
						    }

							var slideIndex = slidenumber;
								$('.slide-tool-content-block-wrapper' ).slick('slickGoTo', slideIndex, false);
								$('.slide-tool-navigation').removeClass('active');
								$('.slick-all').removeClass('visible');
								$('.slick-all').text(function(i, text){
								  return text === "Show Tools" ? "Hide Tool List" : "Show Tools";
								});


				              setTimeout(function() {

											$('.slide-navigation-next-tooltype').focus();

								}, 1);



						});	    
						closeToolWindow();
	         });
		
		    $([document.documentElement, document.body]).animate({
		        scrollTop: $('.section-content-related').offset().top
		    }, 250);





		});

}


function loadToolCategoryByMobile() {

		$('a.tool-link').click(function(e) {
        	e.preventDefault();
		    $(this).parent().parent().parent().addClass('active').siblings().removeClass('active');
		    var toolGroup = $(this).attr('rel');
		    var toolGroupName = $(this).attr('data-name');
			var basicURL = site.root + '/wp-json/wp/v2/tool/?tool-types=';
            var fullURL = basicURL + toolGroup + '&per_page=100';
			
			$('.tools-mobile').remove();


			$(this).parent().parent().parent().append('<div class="tools-mobile"></div>');
			$('.tools-mobile').empty();

			fetch(fullURL, {
			    method: 'GET',
			    headers:{
			        'Content-Type': 'application/json',
			        'accept': 'application/json',
			    }
				}).then(function(response){
				    return response.json();
				}).then(function(post){
						// $('.slide-tool-art-wrapper').append('<div class="slide-tool-art"><div class="media-wrapper" style="background-image:url()"></div></div>');
						// $('.slide-tool-content-block-wrapper').append('<div class="slide-tool-content-block"><h2>' + toolGroupName + '</h2></div>');
						// $('.slide-tool-content-wrapper').append('<div class="slide-tool-list"></div>');
					$('.tools-mobile').append('<div class="tools-mobile-list"><ul></ul></div>');
	              	$.each(post, function(i, item) {
				    	var title = post[i].title.rendered;
				    	var content = post[i].content.rendered;
				    	var id = post[i].id;
				    	var link = post[i].link;
						

						$('.tools-mobile-list ul').append('<li rel="' + id + '"><div class="tools-mobile-list-title"><h3>' + title + '</h3></div><button class="toggle-tool-icon mobile"><span class="screen-reader">Open Tool Details</span><div class="toggle-tool-icon-bar toggle-tool-icon-bar-vert">&nbsp;</div><div class="toggle-tool-icon-bar toggle-tool-icon-bar-bottom toggle-tool-icon-bar-bottom-plus">&nbsp;</div></button></li>');






	            	});	              


					setTimeout(function() {

						$('.tools-mobile-list li').click(function(e) {
						    	$(this).toggleClass('active').siblings().removeClass('active');
							    var toolID = $(this).attr('rel');
								var basicURL = site.root + '/wp-json/wp/v2/tool/';
					            var toolURL = basicURL + toolID + '?_embed';
								$('.tools-mobile-list-content-block-wrapper').remove();
								$(this).append('<div class="tools-mobile-list-content-block-wrapper"></div>');
				    			

								fetch(toolURL, {
								    method: 'GET',
								    headers:{
								        'Content-Type': 'application/json',
								        'accept': 'application/json',
								    }
									}).then(function(response){
									    return response.json();
									}).then(function(post){

											
									    	var title = post.title.rendered;
									    	var content = post.content.rendered;
									    	var id = post.id;
									    	var image = post.acf.image;
									    	var link = post.link;
											var toolImage = post._embedded['wp:featuredmedia'][0].source_url;
      										var image = site.themePath + '/dist/images/logos/logo-pattern.png';
											if (toolImage != null) {
											        var image = toolImage;
											}

								              setTimeout(function() {
												
												$('.tools-mobile-list-content-block-wrapper').empty();

									              setTimeout(function() {
													$('.active .tools-mobile-list-content-block-wrapper').append('<div class="tools-mobile-list-content-block-wrapper"><img src="' + toolImage + '" alt="' + title + '"><p>' + content + '</p><a href="'+ site.root + '/contact-us/?linkfrom=' + title + '" class="related-link small purple">Speak to a team member about this tool</a></div>');
													}, 20);

												}, 1);

				
						         });
							
							});
	          				
					}, 25);



	          				


	         });
		






		});

}

function loadToolsByCategory() {

		//Get the toolsset title
	    var basicURL = site.root + '/wp-json/wp/v2/tool-types/';
    	var fullURL = basicURL;
		fetch(fullURL, {
			    method: 'GET',
			    headers:{
			        'Content-Type': 'application/json',
			        'accept': 'application/json',
			    }
			}).then(function(response){
			    return response.json();
			}).then(function(post){
              $.each(post, function(i, item) {

		    	var name = post[i].name;
		    	var tool = post[i].id;

				$('.section-tool-list-all').append('<div class="tools tools-' + tool + '"><h4>' + name + ' </h4></div>');

					//Get the tools of the toolset
				    var basicURL = site.root + '/wp-json/wp/v2/tool/?tool-types=';
			    	var fullURL = basicURL + tool + '&orderby=title&order=asc&per_page=100';
					fetch(fullURL, {
						    method: 'GET',
						    headers:{
						        'Content-Type': 'application/json',
						        'accept': 'application/json',
						    }
						}).then(function(response){
						    return response.json();
						}).then(function(post){

			              $.each(post, function(i, item) {
					    	var title = post[i].title.rendered;
					    	var id = post[i].id;
					    	var link = post[i].link;

							$('.tools-' + tool ).append('<div class="tool tool-list tool-' + id + '"><a href="#uwwcet-tools" data-parent="' + tool + '" rel="' + id + '"><span class="screen-reader">View more information about</span> ' + title + '</a></div>');

							$('.tool-' + id + '').attr('rel', '' + (i+1) + '');

							$('.tool-' + id + '').click(function(e) {
	
					        	e.preventDefault();
								// get the slide number from its rel attribute
								const slidenumber = $(this).index();
								// const slidenumber = $(this).attr('rel');
								// subtract one to go to correct slide
								const slideIndex = slidenumber - 1;

								$('.section-content-related').empty();
								$('.section-content-related').addClass('active');
								$('.section-content-related').append('<div class="slider-tools"><div class="slide-tool slide-tool-art-wrapper"></div><div class="slide-tool-content-wrapper"><div class="slide-tool-form"></div><div class="slide-tool slide-tool-content-block-wrapper"></div></div></div></div>');
										$('.slide-tool-content-wrapper').append('<div class="slide-tool-navigation"><div class="slide-tool-navigation-buttons"><button class="close-modal button-x">Close Tool Viewer</button><button class="slick-arrow-control slick-prev slide-navigation-prev-tooltype">View Previous Tool</button><button class="slick-arrow-control slick-next slide-navigation-next-tooltype">View Next Tool</button></div></div><div class="slide-tool slide-tool-content-block-wrapper"></div></div>');
						$('.slide-tool-navigation-buttons .close-modal').focus();

							    $([document.documentElement, document.body]).animate({
							        scrollTop: $('.section-content-related').offset().top
							    }, 250);


								//Get the tools of the toolset
							    var basicURL = site.root + '/wp-json/wp/v2/tool/?tool-types=';
						    	var fullURL = basicURL + tool + '&orderby=title&order=asc&per_page=100';
								fetch(fullURL, {
									    method: 'GET',
									    headers:{
									        'Content-Type': 'application/json',
									        'accept': 'application/json',
									    }
									}).then(function(response){
									    return response.json();
									}).then(function(post){

						              $.each(post, function(i, item) {
								    	var title = post[i].title.rendered;
								    	var content = post[i].content.rendered;
								    	var id = post[i].id;
								    	// var use = post[i].acf.use_for;
								    	// var cost = post[i].acf.cost_benefit;
								    	// var solutions = post[i].acf.solutions;
								    	var image = post[i].acf.image;
								    	var link = post[i].link;


										$('.slide-tool-art-wrapper').append('<div class="slide-tool-art"><span class="media-wrapper" role="img" aria-label="' + title + '" style="background-image:url(' + image + ')"></span></div>');
										$('.slide-tool-content-block-wrapper').append('<div class="slide-tool-content-block"><h2>' + title + '</h2><p>' + content + '</p><a href="'+ site.root + '/contact-us/?linkfrom=' + title + '" class="related-link small purple">Speak to a team member about this tool</a></div>');

						            });
							

									 $('.slide-tool-art-wrapper').slick({
									  slidesToShow: 1,
									  slidesToScroll: 1,
									  arrows: false,
									  speed: 250,
									  fade: true,
									  asNavFor: '.slide-tool'
									});

									

						              setTimeout(function() {
											$('.slide-tool-content-block-wrapper').slick({
											  slidesToShow: 1,
											  slidesToScroll: 1,
											  asNavFor: '.slide-tool',
											  speed: 500,
											  dots: false,
											  fade: false,
											  prevArrow: $('.slide-navigation-prev-tooltype'),
				      							nextArrow: $('.slide-navigation-next-tooltype'),

											  focusOnSelect: true
											});
										$('.slide-tool-content-block-wrapper' ).slick('slickGoTo', slideIndex, false);

						              }, 25);


										$('.slide-tool-art-wrapper').on('afterChange', function(event, slick, currentSlide){
										    $('.slide-tool-art').addClass('animate');
										});

										$('.slide-home-art-wrapper').on('beforeChange', function(event, slick, currentSlide){
										    $('.slide-tool-art').removeClass('animate');
										});



						            });


							closeAllToolWindow();



							});




			            });

					});	

            });
		});



}


function loadToolsByCategoryMobile() {

		//Get the toolsset title
		$('.section-tool-list-all').empty();


	    var basicURL = site.root + '/wp-json/wp/v2/tool-types/';
    	var fullURL = basicURL;
		fetch(fullURL, {
			    method: 'GET',
			    headers:{
			        'Content-Type': 'application/json',
			        'accept': 'application/json',
			    }
			}).then(function(response){
			    return response.json();
			}).then(function(post){
              $.each(post, function(i, item) {

		    	var name = post[i].name;
		    	var tool = post[i].id;

				$('.section-tool-list-all').append('<div class="tools tools-mobile tools-' + tool + '""><h4>' + name + ' </h4><div class="tools-mobile-list" id="view-all-tools"><ul></ul></div></div>');

					//Get the tools of the toolset
				    var basicURL = site.root + '/wp-json/wp/v2/tool/?tool-types=';
			    	var fullURL = basicURL + tool + '&_embed&orderby=title&order=asc&per_page=100';
					fetch(fullURL, {
						    method: 'GET',
						    headers:{
						        'Content-Type': 'application/json',
						        'accept': 'application/json',
						    }
						}).then(function(response){
						    return response.json();
						}).then(function(post){

			              $.each(post, function(i, item) {
					    	var title = post[i].title.rendered;
					    	var id = post[i].id;
					    	var link = post[i].link;
					    	var content = post[i].content.rendered;
					    	var image = post[i].acf.image;
					    	var link = post[i].link;
							var toolImage = post[i]._embedded['wp:featuredmedia'][0].source_url;
								var imagePattern = site.themePath + '/dist/images/logos/logo-pattern-placeholder.png';
								var image = site.themePath + '/dist/images/logos/logo-pattern.png';
							if (toolImage != null) {
							        var image = toolImage;
							}

							$('#view-all-tools ul').append('<li rel="' + id + '" class="active"><div class="tools-mobile-list-title"><h3>' + title + '</h3></div><div class="tools-mobile-list-content-block-wrapper"><img src="' + imagePattern +' " data-src="' + toolImage + '" class="lazy full" alt="' + title + '"><div class="tools-mobile-list-content-block-wrapper"><p>' + content + '</p><a href="'+ site.root + '/contact-us/?linkfrom=' + title + '" class="related-link small purple">Speak to a team member about this tool</a></div></li>');





			            });



	          				

					});	

            });
		});



}





});



function aboutSlider() {

 $('.slide-tool-art-wrapper').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  speed: 250,
  fade: true,
  asNavFor: '.slide-tool'
});
$('.slide-tool-content-block-wrapper').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.slide-tool',
  speed: 500,
  dots: false,
  fade: false,
  arrows: true,
  focusOnSelect: true
});

	$('.slide-tool-art-wrapper').on('afterChange', function(event, slick, currentSlide){
	    $('.slide-tool-art').addClass('animate');
	});

	$('.slide-home-art-wrapper').on('beforeChange', function(event, slick, currentSlide){
	    $('.slide-tool-art').removeClass('animate');
	});

};


//

// load posts based on id
function closeToolWindow() {
		setTimeout(function() {

		$('.close-modal').click(function(e) {

			$('.section-content-related').removeClass('active');
			$('.slider-tools').remove();

		    document.getElementById("Fabricate").tabIndex = 0;
		    document.getElementById("Test").tabIndex = 0;
		    document.getElementById("Integrate").tabIndex = 0;
		    document.getElementById("Scale").tabIndex = 0;


		    $([document.documentElement, document.body]).animate({
		        scrollTop: $('.section-scroll-tools').offset().top -32
		    }, 950);
				});
		}, 25);

}


// load posts based on id
function closeAlertWindow() {

		$('.close-alert').click(function(e) {

			$('.alert').remove();
				});

}

// load posts based on id
function closeAllToolWindow() {
		setTimeout(function() {

		$('.close-modal').click(function(e) {

			$('.section-content-related').removeClass('active');
			$('.slider-tools').remove();

		    document.getElementById("Fabricate").tabIndex = 0;
		    document.getElementById("Test").tabIndex = 0;
		    document.getElementById("Integrate").tabIndex = 0;
		    document.getElementById("Scale").tabIndex = 0;


		    $([document.documentElement, document.body]).animate({
		        scrollTop: $('#our-tools').offset().top -32
		    }, 950);
				});
		}, 25);

}



	

// load posts based on id
function loadToolByID() {

		$('.section-content-related').addClass('active');
		$('.section-content-related').append('<div class="slider-tools "><div class="slide-tool slide-tool-art-wrapper"></div><div class="slide-tool-content-wrapper"><div class="slide-tool slide-tool-content-block-wrapper"></div></div></div></div>');
		
			var toolID = getParameterByName('toolID');
			var basicURL = site.root + '/wp-json/wp/v2/tool/';
            var fullURL = basicURL + toolID;
			fetch(fullURL, {
			    method: 'GET',
			    headers:{
			        'Content-Type': 'application/json',
			        'accept': 'application/json',
			    }
				}).then(function(response){
				    return response.json();
				}).then(function(post){
					window.location.hash = '#uwwcet-tools';
			    	var title = post.title.rendered;
			    	var content = post.content.rendered;
			    	var id = post.id;
			    	// var use = post[i].acf.use_for;
			    	// var cost = post[i].acf.cost_benefit;
			    	// var solutions = post[i].acf.solutions;
			    	var image = post.acf.image;
			    	var link = post.link;
						$('.slide-tool-art-wrapper').append('<div class="slide-tool-art animate"><span class="media-wrapper" role="img" aria-label="' + title + '" style="background-image:url(' + image + ')"></div></span>');
						$('.slide-tool-content-block-wrapper').append('<div class="slide-tool-navigation"><div class="slide-tool-navigation-buttons"><button class="close-modal button-x">Close Tool Viewer</button></div></div><div class="slide-tool-content-block single"><h2>' + title + '</h2><p>' + content + '</p><a href="'+ site.root + '/contact-us/?linkfrom=' + title + '" class="related-link small purple">Speak to a team member about this tool</a></div>');
						$('.slide-tool-navigation-buttons .close-modal').focus();
				
							closeToolWindow();

	        });
			


		    $([document.documentElement, document.body]).animate({
		        scrollTop: $('.section-content-related').offset().top
		    }, 950);




	}



function getParameterByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


		 //    var postID = $(this).attr('rel');
			// var toolArr = postID.split(', ');

			// const tools = toolArr;
			
   //          tools.forEach(function(tool){
			// 	var basicURL = site.root + '/wp-json/wp/v2/tool/?tool-types=';
   //                 var fullURL = basicURL + tool;
   //                  fetch(fullURL, {
   //                        method: 'GET',
   //                        headers:{
   //                            'Content-Type': 'application/json',
   //                            'accept': 'application/json',
   //                        }
   //                    }).then(function(response){
   //                        return response.json();
   //                    }).then(function(post){



   //                    });

   //          });
